import { render, staticRenderFns } from "./page9.vue?vue&type=template&id=e6acb8f6&scoped=true"
import script from "./page9.vue?vue&type=script&lang=js"
export * from "./page9.vue?vue&type=script&lang=js"
import style0 from "./page9.vue?vue&type=style&index=0&id=e6acb8f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6acb8f6",
  null
  
)

export default component.exports